import * as types from "../dashboardActionTypes";

const initialState = {
    lowSeverities: 0,
    mediumSeverities: 0,
    highSeverities: 0
};

export default function securityAlertsLastMonthReducer(state = initialState, action) {
    switch(action.type) {
        case types.LOAD_SECURITY_ALERTS_LAST_MONTH_SUCCESS:
            return action.securityAlertsLastMonth;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/dashboard/reducers/securityAlertsLastMonthReducer.js